import * as React from 'react';
import classnames from 'classnames';

interface ISpinnerProps {
    size?: string;
    className?: string;
}
const Spinner: React.SFC<ISpinnerProps> = ({ size, className }) => {
    return (
        <div
            className={classnames('spinner', {
                [size]: true,
                className
            })}
        >
            <div
                className={classnames('spinningCircle', {
                    [size]: true,
                    className
                })}
            />
        </div>
    );
};

export default Spinner;
